<template>
  <div
    class="flex max-md:flex-col overflow-hidden items-center md:py-28 py-10 justify-between bg-primary-1 border-curve md:bg-[url('https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/food-&-drink.png')] bg-[url(https://turpal-web.fra1.cdn.digitaloceanspaces.com/assets/food-and-drink-mobile.png)] bg-contain"
  >
    <div class="w-full flex flex-col md:px-10 px-5">
      <span class="text-white md:text-heading-6 text-mobile-heading-6">
        {{ cityName }}
      </span>
      <div
        class="flex flex-col [&_img]:inline-block [&_img]:align-middle [&_img]:w-[50px] [&_img]:h-[50px] text-white md:text-heading-2 text-mobile-heading-2"
      >
        <span>{{ t("discover.experienceTheBest") }} </span>
        <div class="text-primary-2">
          {{ t("discover.food") }}
          <NuxtImg loading="lazy" v-no-right-click src="noodle.svg" alt=" " />
          {{ t("discover.&drink") }}
          <NuxtImg loading="lazy" v-no-right-click src="drink.svg" alt=" " />
        </div>
        {{ t("discover.inTheWhole") }} {{ cityName }}
      </div>
      <div class="flex mt-5 gap-4 p-1 max-md:hidden">
        <div class="navigation-btn" @click="handlePrevSlide">
          <icon-chevron class="ltr:rotate-180 !m-0" />
        </div>
        <div class="navigation-btn" @click="handleNextSlide">
          <icon-chevron class="!m-0 rtl:rotate-180" />
        </div>
      </div>
      <BaseButton
        class="!border-curve w-fit md:mt-5 mt-3"
        type="primary"
        :label="t('discover.viewFoodExperience')"
        hover-background-color="white"
        hover-color="primary-2"
        color="white"
        @click="handleViewAllProducts"
      />
    </div>
    <div class="md:max-w-[50%] w-full h-full max-md:mt-14">
      <Swiper
        class="md:!pe-10 max-md:!px-5 [&_.swiper-button-next]:hidden [&_.swiper-button-prev]:hidden -my-1 !py-1"
        :slides-per-view="2.2"
        :loop="true"
        :space-between="20"
        :modules="[Navigation, Mousewheel]"
        :mousewheel="{
          forceToAxis: true,
          sensitivity: 1,
        }"
        :navigation="true"
        :breakpoints="breakpoints"
        @swiper="onSwiper"
      >
        <SwiperSlide v-for="item in products" :key="item.id" class="">
          <LazyProductCardHandler
            :key="item.id"
            class="bg-primary-1 border-[1px] border-gray-2 border-curve [&_.content]:px-2.5"
            :card-type="type"
            :item="item"
            :vertical="true"
            :dark-mode="true"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IProduct } from "../../types/general";
import { reactive, ref, type PropType } from "vue";
import { Navigation, Mousewheel } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { useRouter } from "vue-router";
import { Swiper, SwiperSlide } from "swiper/vue";

defineProps({
  products: { type: Array as PropType<IProduct[]>, required: true },
  title: {
    type: String,
    required: true,
  },
  cityName: {
    type: String,
    required: true,
  },
});
const type = ref(useRuntimeConfig().public.statics.productCardType);
const localePath = useLocalePath();
const router = useRouter();
const emit = defineEmits(["scroll-to-activities"]);
const { t } = useI18n();
const breakpoints = reactive({
  320: {
    slidesPerView: 1.8,
    slidesPerGroup: 1,
    spaceBetween: 20,
  },
  960: {
    slidesPerView: 2.2,
    slidesPerGroup: 1,
    spaceBetween: 20,
  },
});

const swiperInstance = ref<any>(null);

const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};

const handleNextSlide = () => {
  if (swiperInstance.value) {
    swiperInstance.value.navigation.nextEl.click();
  }
};

const handlePrevSlide = () => {
  if (swiperInstance.value) {
    swiperInstance.value.navigation.prevEl.click();
  }
};

const handleViewAllProducts = () => {
  router.push(
    localePath({
      name: "things-to-do-in-slug",
      query: { category: "food-drink" },
    })
  );
  emit("scroll-to-activities");
};
</script>

<style scoped>
.navigation-btn {
  @apply flex items-center justify-center !rounded-full !p-2.5 !w-[40px] !h-[40px] !border !text-gray-4 !border-gray-4 hover:!text-primary-1 hover:bg-gray-4 transition-all duration-300 !cursor-pointer;
}
</style>
